import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";
import { Link } from "react-router-dom";
import { SeverityBadge, StatusBadge } from "@/components/Primitives";
import { Search } from "lucide-react";

export default function Tickets() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [priority, setPriority] = useState("");
  useEffect(() => { api.get("/tickets", { params: { limit: 500 } }).then(r => setItems(asArray(r.data))).catch(() => setItems([])); }, []);
  const filtered = items.filter(t => !q || (t.title || "").toLowerCase().includes(q.toLowerCase())).filter(t => !status || t.status === status).filter(t => !priority || t.priority === priority);
  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Service Desk · PSA</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Tickets ({filtered.length})</h1>
        </div>
        <div className="flex gap-2">
          <div className="relative">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
            <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search tickets" data-testid="ticket-search" className="bg-zinc-950 border border-zinc-800 rounded-md pl-9 pr-3 py-1.5 text-sm w-72 focus:outline-none focus:border-blue-500/60" />
          </div>
          <select value={status} onChange={e=>setStatus(e.target.value)} data-testid="ticket-status-filter" className="bg-zinc-950 border border-zinc-800 rounded-md px-3 py-1.5 text-sm">
            <option value="">All status</option>
            <option value="open">Open</option>
            <option value="in_progress">In Progress</option>
            <option value="pending">Pending</option>
            <option value="closed">Closed</option>
          </select>
          <select value={priority} onChange={e=>setPriority(e.target.value)} data-testid="ticket-priority-filter" className="bg-zinc-950 border border-zinc-800 rounded-md px-3 py-1.5 text-sm">
            <option value="">All priority</option>
            <option value="critical">Critical</option>
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
          </select>
        </div>
      </div>

      <div className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 border-b border-zinc-900 text-[10px] uppercase tracking-widest text-zinc-500 font-mono">
            <tr>
              <th className="text-left px-4 py-3 w-20">#</th>
              <th className="text-left px-4 py-3">Title</th>
              <th className="text-left px-4 py-3">Category</th>
              <th className="text-left px-4 py-3">Priority</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">SLA</th>
              <th className="text-left px-4 py-3">Created</th>
            </tr>
          </thead>
          <tbody>
            {filtered.slice(0, 200).map(t => (
              <tr key={t.id} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="px-4 py-2 font-mono text-zinc-500 text-xs">#{t.number}</td>
                <td className="px-4 py-2"><Link to={`/tickets/${t.id}`} className="hover:text-blue-400" data-testid={`ticket-link-${t.id}`}>{t.title}</Link></td>
                <td className="px-4 py-2 text-zinc-400">{t.category}</td>
                <td className="px-4 py-2"><SeverityBadge level={t.priority} /></td>
                <td className="px-4 py-2"><StatusBadge status={t.status} /></td>
                <td className="px-4 py-2 font-mono text-[11px] text-zinc-500">{t.sla_deadline?.slice(0,10)}</td>
                <td className="px-4 py-2 font-mono text-[11px] text-zinc-500">{t.created_at?.slice(0,10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
